import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  listSentidos:[],
};
export const mutations = {
  GET_SENTIDOS({ context }, sentidos) {
    let sentidos_array = [];
    Object.entries(sentidos).forEach(([key, val]) => sentidos_array.push(val));
    return (state.listSentidos = sentidos_array);
  },
};
export const actions = {
  GET_SENTIDOS({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_SENTIDOS", response.data.data.sentidos);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  GET_SENTIDOS_CATALOGO({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          // commit("GET_SENTIDOS_CATALOGO", response.data.data.sentidos);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  GET_SENTIDO({ commit }, data) { //axios, mandar parametros para post
    // console.log(data);
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          // console.log(response.data);
          // commit("SET_LOADING", false);
          // commit("GET_SALA", response.data.data.sala);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  SAVE_SENTIDO({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(data)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          // commit("SAVE_DELITO", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  EDIT_SENTIDO({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.put(data)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          // commit("EDIT_DELITO", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
      });
    },

    DELETE_SENTIDO({ commit }, id) { //axios, mandar parametros para post
      return new Promise((resolve, reject) => {
        commit("SET_LOADING", true);
        ApiService.delete(id)//funcion de ApiService
          .then(response => {
            //console.log("store",response);
            commit("SET_LOADING", false);
            resolve(response);
          })
          .catch(error => {
            commit("SET_LOADING", false);
            reject(error);
          });
      });
    },

};

export const getters = {//leer datos
  listSentidos: state => state.listSentidos,
};
